document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("create_customer");

  if (!form) return;

  const submitButton = document.getElementById("registerBtn");
  const returnToInput = document.getElementById("RegisterForm-return-to");
  const localeInput = document.getElementById("RegisterForm-locale");

  let isSubmittingToShopify = false;

  function getSafeReturnTo() {
    const params = new URLSearchParams(window.location.search);
    const returnTo = params.get("return_to");

    // Only allow internal paths to prevent open redirects.
    if (returnTo && returnTo.startsWith("/") && !returnTo.startsWith("//")) {
      return returnTo;
    }

function getLocalizedAccountUrl() {
  const path = window.location.pathname;

  const match = path.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
  const locale = match ? `/${match[1]}` : "";

  return `${locale}/account`;
}

function normalizeReturnTo(url) {
  if (!url) return "";

  return url.replace(/^\/([a-z]{2}(?:-[a-z]{2})?)account$/i, "/$1/account");
}

return normalizeReturnTo(returnToInput?.value) || getLocalizedAccountUrl();
  }

  function setReturnToInput() {
    if (!returnToInput) return;

    returnToInput.value = getSafeReturnTo();
  }

  setReturnToInput();

  form.addEventListener("submit", async function (e) {

    const password = form.querySelector("#RegisterForm-password").value;

    if (!password || password.length < 8) {
      e.preventDefault(); // 🚨 STOP SHOPIFY
      e.stopImmediatePropagation(); // 🚨 STOP OTHER LISTENERS
      alert("Password must be at least 8 characters.");
      return false;
    }

  const formData = new FormData(form);
    const userData = {
      first_name: formData.get("customer[first_name]"),
      last_name: formData.get("customer[last_name]"),
      email: formData.get("customer[email]").toLowerCase(),
      password: password,
      is_medical_user: false
    };

    try {
      const response = await fetch(
        "https://microbiome-api-mjmpwq5lsa-ez.a.run.app/api/v1/users/register?design=default",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "accept": "application/json"
          },
          body: JSON.stringify({
            user_in: userData,
            language: "en",
            turnstile_token: "",
            source: "shopify"
          })
        }
      );

      const data = await response.json();

    // ✅ Handle known API errors here, before Shopify submit
    if (!response.ok) {
      const apiMessage =
        data?.message ||
        data?.detail ||
        data?.error ||
        "";

      const normalizedMessage = String(apiMessage).toLowerCase();

      if (
        response.status === 409 ||
        normalizedMessage.includes("already") ||
        normalizedMessage.includes("exists") ||
        normalizedMessage.includes("email")
      ) {
        showRegisterError("An account already exists with this email address. Please log in instead.");
        return false;
      }

      showRegisterError(apiMessage || "Registration failed. Please try again.");
      return false;
    }

      // ✅ Save token
      localStorage.setItem("token", data.access_token);

      const d = new Date();
      d.setTime(d.getTime() + (8 * 24 * 60 * 60 * 1000));

      document.cookie =
        "token=" +
        data.access_token +
        ";expires=" +
        d.toUTCString() +
        ";path=/;Domain=innerbuddies.com;";

      // ✅ NOW allow Shopify to create account
      form.submit();

    } catch (error) {
      console.error("Registration error:", error);
      alert("Registration failed. Please try again.");
    }
  });
});
